import styled from "styled-components";

export const IconWrapper = styled.i`
  margin-right: 4px;
  color: var(--denim);
`;
